import styled from 'styled-components';

export const ContainerFile = styled.div`
  border: 1px dashed #e5eaee;
  border-radius: 5px;
  background-color: #fcfcfc;
  padding: 15px;
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  max-width: 100%;

  overflow: hidden;

  cursor: default;

  .icon {
    margin-bottom: 10px;
  }

  input[type='file'] {
    display: none;
  }

  .clear-button {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1px solid #e5eaee;
    background: #ffffff;
    color: #6b6f76;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .clear-button:hover {
    background: #f5f7fa;
    color: #3b3f45;
  }
`;

export const PreviewGrid = styled.div`
  display: grid;
  grid-template-columns: ${({ $single }) => ($single ? '1fr' : 'repeat(3, 1fr)')};
  gap: 8px;
  width: 100%;
  margin-bottom: 16px;
`;

export const PreviewItem = styled.div`
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  background: #f0f0f0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  will-change: transform;

  img {
    display: block;
    width: 100%;
    height: auto;
    object-fit: contain;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: high-quality;
  }
`;

export const RemoveButton = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.6);
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  z-index: 1;
  line-height: 1;

  &:hover {
    background: rgba(220, 38, 38, 0.85);
  }
`;

export const PdfPreviewWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  pointer-events: none;

  .react-pdf__Page {
    display: flex;
    justify-content: center;
  }

  .react-pdf__Page__canvas {
    width: 100% !important;
    height: auto !important;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
  }
`;

export const UploadTrigger = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  width: 100%;
  padding-top: 4px;
`;
